export enum DefaultMessage {
  ERROR = 'Opss... Todo mundo erra, e dessa vez fomos nós. Tente  novamente por favor!',
}
